import React from 'react';
import { slideoutData } from '../data/servicesData';

/**
 * ServiceSlideout Component
 * Renders the slideout panel content for a given service
 * 
 * @param {string} serviceName - The name of the service to display
 */
function ServiceSlideout({ serviceName }) {
  const data = slideoutData[serviceName];
  
  if (!data) {
    return null;
  }

  return (
    <>
      <h3 className="service-slide-title">{data.title}</h3>
      <img 
        src={data.image} 
        alt={data.imageAlt} 
        className="service-slide-image" 
      />
      <div className="service-slide-content">
        <p className="service-slide-intro">{data.intro}</p>
        
        {data.text && (
          <p className="service-slide-text">{data.text}</p>
        )}
        
        <h4 className="service-slide-subtitle">{data.subtitle}</h4>
        
        {data.subtitleText && (
          <p className="service-slide-text">{data.subtitleText}</p>
        )}
        
        <ul className="service-slide-list">
          {data.features.map((feature, index) => (
            <li key={index}>
              <strong>{feature.bold}</strong> {feature.text}
            </li>
          ))}
        </ul>
        
        {/* Second section (for services with two feature lists) */}
        {data.secondSubtitle && (
          <>
            <h4 className="service-slide-subtitle">{data.secondSubtitle}</h4>
            {data.secondSubtitleText && (
              <p className="service-slide-text">{data.secondSubtitleText}</p>
            )}
            {data.secondFeatures && (
              <ul className="service-slide-list">
                {data.secondFeatures.map((feature, index) => (
                  <li key={index}>
                    <strong>{feature.bold}</strong> {feature.text}
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
        
        {data.quote && (
          <p className="service-slide-quote">
            <em>"{data.quote}"</em>
          </p>
        )}
      </div>
    </>
  );
}

export default ServiceSlideout;
